<template>
  <teleport to="body" v-if="isVisible">
    <div :id="id" :class="['modal b-modal-kariermu', { 'd-block bg-overlay fade': isVisible, 'show': shouldAppendShowClass }, modalClass]">
      <div class="modal-dialog" :class="[{ 'modal-dialog-centered': centered }, modalDialogClass, modalDialogSizeClass, modalDialogScrollableClass]">
        <div class="modal-content" :class="modalContentClass">
          <div class="modal-header" :class="[{ 'border-bottom-0' : hideHeaderBorder }, modalHeaderClass]"  v-if="!hideHeader">
              <slot name="modal-header"></slot>
              <slot name="modal-close-button" :close="close">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </slot>
          </div>
          <div class="modal-body" :class="modalBodyClass">
            <slot name="content"></slot>
          </div>
          <div class="modal-footer" :class="[{ 'border-top-0' : hideFooterBorder }, modalFooterClass]" v-if="!hideFooter">
            <slot name="modal-footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script>
export default {
  name: 'BModalKariermu', // Bootstrap Modal Kariermu
  props: {
    centered: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    isShown: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideHeaderBorder: {
      type: Boolean,
      default: true
    },
    hideFooterBorder: {
      type: Boolean,
      default: true
    },
    modalClass: {
      type: String,
      default: ''
    },
    modalDialogClass: {
      type: String,
      default: ''
    },
    modalContentClass: {
      type: String,
      default: ''
    },
    modalHeaderClass: {
      type: String,
      default: ''
    },
    modalBodyClass: {
      type: String,
      default: ''
    },
    modalFooterClass: {
      type: String,
      default: ''
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '',
      validator (value) {
        return ['', 'sm', 'lg', 'xl'].includes(value)
      }
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      required: false
    },
    onHidden: {
      type: Function,
      required: false
    },
    onShown: {
      type: Function,
      required: false
    }
  },
  emits: ['change', 'close', 'hidden', 'shown'],
  data () {
    return {
      isVisible: false,
      shouldAppendShowClass: false
    }
  },
  computed: {
    modalDialogSizeClass () {
      return this.size ? `modal-${this.size}` : ''
    },
    modalDialogScrollableClass () {
      return this.scrollable ? 'modal-dialog-scrollable' : ''
    }
  },
  methods: {
    open () {
      this.isVisible = true
      this.$emit('change', true)
      setTimeout(() => {
        this.shouldAppendShowClass = true
        this.onShownHandler()
      }, 100)
    },
    close () {
      this.onCloseHandler()
      this.shouldAppendShowClass = false
      this.$emit('change', false)
      setTimeout(() => {
        this.isVisible = false
        this.onHiddenHandler()
      }, 100)
    },
    handleEscKey (e) {
      if (e.keyCode === 27 && !this.noCloseOnEsc) {
        this.close()
      }
    },
    onCloseHandler () {
      if (typeof this.onClose === 'function') {
        this.$emit('close')
      }
    },
    onHiddenHandler () {
      if (typeof this.onHidden === 'function') {
        this.$emit('hidden')
      }
    },
    onShownHandler () {
      if (typeof this.onShown === 'function') {
        this.$emit('shown')
      }
    }
  },
  watch: {
    isShown: {
      immediate: true,
      handler (value) {
        if (value) {
          this.open()
          if (!this.noCloseOnEsc) document.addEventListener('keydown', this.handleEscKey)
          document.body.style.overflow = 'hidden'
        } else {
          this.close()
        }
      }
    }
  },
  beforeUnmount () {
    if (!this.noCloseOnEsc) document.removeEventListener('keydown', this.handleEscKey)
    document.body.style.overflow = 'auto'
  }

}
</script>
